import { render, staticRenderFns } from "./ConfigureModalitySection.vue?vue&type=template&id=2faee7ee"
import script from "./ConfigureModalitySection.vue?vue&type=script&lang=js"
export * from "./ConfigureModalitySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports